import sha1 from "sha1";
import { LoginStatus } from "../../constants/loginStatus";

const API_URL = process.env.REACT_APP_API_URL;

export async function authenticateUser({ username, password }) {
	const encryptedPassword = sha1(password);
	const userCredentials = { userId: username, password: encryptedPassword };

	const res = await fetch(API_URL + "/login", {
		method: "post",
		body: JSON.stringify(userCredentials),
		headers: {
			"Content-Type": "application/json",
		},
	});
	const data = await res.json();
	const row = data?.ResultSet?.row?.[0] ?? {};
	const meta = data?.MetaInfo?.[0] ?? {};

	if (row.status === LoginStatus.LOGIN_SUCCESS) {
		const user_state = { ...meta, ...row };
		return {
			status: row.statusCode,
			message: row.message,
			state: user_state,
		};
	}

	return {
		status: row.statusCode,
		message: row.message,
		attemptsRemaining: row.attemptsRemaining,
	};
}

export async function refreshAccessToken(refreshToken) {
	const res = await fetch(API_URL + "/login/refresh", {
		method: "POST",
		body: JSON.stringify({ refreshToken }),
		headers: {
			"Content-Type": "application/json",
		},
	});
	// Outcome lives in the body status, not the HTTP status — read it regardless of res.ok.
	const data = await res.json().catch(() => ({}));
	const row = data?.ResultSet?.row?.[0] ?? {};

	if (row.status === LoginStatus.REFRESH_SUCCESS && row.accessToken) {
		return {
			accessToken: row.accessToken,
			refreshToken: row.refreshToken,
			expiresIn: row.expiresIn,
		};
	}

	// INVALID_REFRESH_TOKEN / PASSWORD_EXPIRED / BAD_REQUEST — carry the reason for callers to act on.
	const err = new Error(row.message || "Failed to refresh token");
	err.status = row.status;
	err.statusCode = row.statusCode;
	throw err;
}
